import { useEffect } from 'react';
import webSocketService from '../../services/websocket.service';
import { getLoggedinUser } from '../../helpers/api_helper';

const WebSocketInitializer = () => {
  useEffect(() => {
    const currentUser = getLoggedinUser();
    
    if (currentUser?.token) {
      console.log('WebSocketInitializer: Connecting WebSocket for user');
      webSocketService.connect();
    }

    return () => {
      // Don't disconnect on unmount - we want to keep the connection alive
    };
  }, []);

  return null;
};

export default WebSocketInitializer;